import { Injectable, Component, OnInit } from '@angular/core';
import { Jsonp, URLSearchParams } from '@angular/http';  
import { Http, Response, Headers } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/map'

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {
  constructor(private jsonp: Jsonp, private http: Http, private route: ActivatedRoute) { }; 
  private path = 'http://www.cloudfactory.eu/rest/wp-json/wp/v2/pages';
  private url:string;
  public pages:any;
  public page:any;
  public loading:boolean = false;
  private id: number;
  private error = {
                    status : null,
                    message : null,
                    statusText: null
                  };

  ngOnInit(){
    this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.url = this.path;
      if(this.id){
        this.url += "/" + this.id;
      } 
      this.getPages();
    });
  }

  getPages(){
    this.reset();
    let params = new URLSearchParams();
    let timeStamp = ""+new Date();    
    params.set('tsp', timeStamp);  
    this.loading = true;
    this.http.get(this.url, { search: params })
    .subscribe(
      data => {
        this.pages = JSON.parse(data["_body"]);
        // console.log(JSON.parse(data["_body"]));
        this.loading = false;
      },
      error => {
        this.error.status = error.status;
        this.error.statusText = error.statusText;
        let errorBody = JSON.parse(error["_body"]);
        this.error.message = " " + errorBody["message"];
        this.loading = false;
        // console.error(error);
      });
  }

  getPage(i){
    // this.page = this.pages[i];
  }

  reset(){
    this.pages = null;
    this.error.status = null;
    this.error.statusText = null;
    let errorBody = null;
    this.error.message = null;
  }

}
 


// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/components/pages/pages.component.ts